// extracted by mini-css-extract-plugin
export default {"root":"VideoFormatSelectionForm_root__8lJHn"};